import { fork, all } from "redux-saga/effects";
import { sagaPropertyDesc } from "../AiMarketingHub/PropertyDescription/PropertDescriptionSaga";
import { sagaHistory } from "../AiMarketingHub/History/HistorySaga";
import { sagaEmailDesc } from "../AiMarketingHub/EmailGeneration/EmailGenerationSaga";
import { sagaSocialMediaDesc } from "../AiMarketingHub/SocialMediaCaption/SocialMediaCaptionSaga";
import { sagaAimhLandingPage } from "../AiMarketingHub/AimhLandingPage/AimhLpSaga";
import { sagaRewriteParagraph } from "../AiMarketingHub/RewriteParagraph/RewriteParagraphSaga";
import { sagaFlyers } from "../Flyers/FlyersSaga";
import { sagaAbDesc } from "../AiMarketingHub/AgentsBio/AgentsBioSaga";

export function* watchSagas() {
    yield all([
        fork(sagaPropertyDesc),
        fork(sagaHistory),
        fork(sagaEmailDesc),
        fork(sagaSocialMediaDesc),
        fork(sagaAimhLandingPage),
        fork(sagaRewriteParagraph),
        fork(sagaFlyers),
        fork(sagaAbDesc),
    ]);
}
